import { Typography } from '@mui/material'
import { formatDate, formatStringDate } from '../../utils/Utils'

interface Props {
  data: {
    contents: Array<{
      submitted: number
    }>
  }
}

const SitemapUrls = ({ data }: Props) => {

  if(!data.contents){
    return
  }

  const totalSubmitted = data.contents?.reduce((sum, item) => sum + item.submitted, 0);

  return (
    <Typography>{totalSubmitted}</Typography>
  )
}

export default SitemapUrls;